import { render, staticRenderFns } from "./placard_account_details.vue?vue&type=template&id=eada79dc&scoped=true"
import script from "./placard_account_details.vue?vue&type=script&lang=js"
export * from "./placard_account_details.vue?vue&type=script&lang=js"
import style0 from "./placard_account_details.vue?vue&type=style&index=0&id=eada79dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eada79dc",
  null
  
)

export default component.exports